<template>
  <div>
    <div class="fixed bottom-8 right-4 z-50">
      <div class="relative group">
        <div class="absolute right-full mr-3 top-1/2 transform -translate-y-1/2 bg-gray-800 text-white text-sm px-3 py-2 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap pointer-events-none">
          Help me to book
          <div class="absolute left-full top-1/2 transform -translate-y-1/2 w-0 h-0 border-l-8 border-l-gray-800 border-t-4 border-t-transparent border-b-4 border-b-transparent"></div>
        </div>
        
        <NuxtLink
          to="https://wa.me/62818881388?text=Hi%20Surya%20Bintang%20Adventures%2C%20I%20came%20across%20your%20website%20and%20am%20interested%20in%20your%20activities.%20Can%20you%20help%20me%20book%3F"
          no-prefetch
          class="flex items-center justify-center w-16 h-16 bg-green-500 hover:bg-green-600 text-white rounded-full shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-110 cursor-pointer"
        >
          <Icon name="i-logos-whatsapp-icon" class="text-2xl" />
        </NuxtLink>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts"></script>

<style scoped></style>
